import React from 'react';
import { StarIcon } from '@heroicons/react/solid';
import TestimonialCard from "./TestimonialCard"; 
const testimonials = [
  {
    name:'Masood el-Assaf ',
    image: "https://i.ibb.co/R0F6LxT/muslim-man-having-online-conversation-min.jpg",
    rating: 5,
    testimony: 'Absolutely amazing experience! The platform is easy to use, and the support is fantastic.',
  },
  {
    name:"Sahheeda al-Farag",
    image: "https://i.ibb.co/jRLm8TC/modern-muslim-woman-wearing-headscarf-walking-street-min.jpg",
    rating: 4,
    testimony: 'Great features and very user-friendly. I have seen a great ROI using this platform.',
  },
  {
    name: 'Aneesa el-Rahim',
    image:"https://i.ibb.co/yXBn0c7/hijab-3575501-640-min.jpg",
    rating: 5,
    testimony: 'Excellent service! The interface is intuitive and the support is quick and helpful.',
  },
];

// Individual Testimonial Card
// Testimonials Component
const Rating = () => {
  return (
    <div className="bg-gradient-to-r from-gray-50 to-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-extrabold text-gray-800 text-center mb-12">
          What Our Customers Are Saying
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`opacity-0 animate-fadeInUp delay-${index * 200}`}
              style={{ animationDelay: `${index * 300}ms` }}
            >
              <TestimonialCard
                image={testimonial.image}
                name={testimonial.name}
                rating={testimonial.rating}
                testimony={testimonial.testimony}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Rating;

